LoginForgotController.$inject = [
    '$scope',
    'Club',
    'Backoffice',
    'User',
    '_',
    '$state',
];

/* @ngInject */
function LoginForgotController($scope, Club, Backoffice) {
    var vm = this;
    vm.title = 'LoginForgotController';

    vm.loading = true;
    vm.email = '';
    vm.error = null;
    vm.success = false;
    vm.submit = submit;

    activate();

    ////////////////

    function activate() {
        vm.loading = false;
    }

    function submit() {
        vm.error = null;

        // Angular deja vm.email en undefined si el texto no tiene formato de
        // email, y en '' si está vacío: los dos casos caen acá.
        if (!vm.email) {
            vm.error = 'Ingresá un email válido.';
            return;
        }

        vm.loading = true;

        Backoffice.api
            .forgotPassword({
                email: vm.email,
                sportclub_permalink: Club.permalink,
            })
            .then(function () {
                vm.success = true;
            })
            .catch(function (e) {
                console.error(e);
                // Solo los errores que el SDK marca como user_facing traen un
                // mensaje mostrable; el resto (red, 500) es técnico.
                vm.error = e.user_facing
                    ? e.message
                    : 'Ocurrió un error inesperado. Si persiste contacte a soporte';
            })
            .finally(function () {
                vm.loading = false;
                // La promesa del SDK es nativa: Angular no se entera solo.
                $scope.$apply();
            });
    }
}

export default LoginForgotController;
